var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._t("default"),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("number")(_vm.data.avg_sales_7f_quantity)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("number")(_vm.data.stock_7f)))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }